import gql from "graphql-tag";

const DeleteAlerts = gql`
    mutation DeleteAlerts($input: [DeleteAlertInput!]!, $reason: Int) {
        DeleteAlerts(input: $input, reason: $reason)
    }
`;

export default DeleteAlerts;
